/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { parsers } from '@codegrade/utils';
import { BaseNotification } from './BaseNotification';
const NotificationGeneralFeedbackReplyNotificationAsJSONParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(
/* #__PURE__ */ parsers.object([
    ['type', /* #__PURE__ */ parsers.exactly('general_comment_notification')],
]), BaseNotification);
export class NotificationGeneralFeedbackReplyNotificationAsJSON extends BaseNotification {
    static decode(input) {
        return NotificationGeneralFeedbackReplyNotificationAsJSONParser.decode(input).map(res => new NotificationGeneralFeedbackReplyNotificationAsJSON(res));
    }
    static unsafeDecode(input) {
        return NotificationGeneralFeedbackReplyNotificationAsJSON.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return NotificationGeneralFeedbackReplyNotificationAsJSONParser.encode(data);
    }
    static schema() {
        return NotificationGeneralFeedbackReplyNotificationAsJSONParser.schema();
    }
}
